export default __webpack_public_path__ + "static/media/direction-left.5d8c33fd.svg";